import { css, type ExecutionContext } from 'styled-components'

type CustomTypography002Props = {
  screen14?: boolean
  screen16?: boolean
  screen18?: boolean
  screen20?: boolean
  screen24?: boolean
  screen28?: boolean
  screen32?: boolean
  screen36?: boolean
  screen38?: boolean
  screen40?: boolean
  screen52?: boolean
  screen64?: boolean
}

const screen64Css = ({ screen64 }: ExecutionContext & { screen64?: boolean }) =>
  screen64 &&
  css`
    font-size: 64px;
    line-height: 64px;
  `

const screen52Css = ({ screen52 }: ExecutionContext & { screen52?: boolean }) =>
  screen52 &&
  css`
    font-size: 52px;
    line-height: 62px;
  `

const screen40Css = ({ screen40 }: ExecutionContext & { screen40?: boolean }) =>
  screen40 &&
  css`
    font-size: 40px;
    line-height: 44px;
  `

const screen38Css = ({ screen38 }: ExecutionContext & { screen38?: boolean }) =>
  screen38 &&
  css`
    font-size: 38px;
    line-height: 40px;
  `

const screen36Css = ({ screen36 }: ExecutionContext & { screen36?: boolean }) =>
  screen36 &&
  css`
    font-size: 36px;
    line-height: 40px;
  `

const screen32Css = ({ screen32 }: ExecutionContext & { screen32?: boolean }) =>
  screen32 &&
  css`
    font-size: 32px;
    line-height: 40px;
  `

const screen28Css = ({ screen28 }: ExecutionContext & { screen28?: boolean }) =>
  screen28 &&
  css`
    font-size: 28px;
    line-height: 36px;
  `

const screen24Css = ({ screen24 }: ExecutionContext & { screen24?: boolean }) =>
  screen24 &&
  css`
    font-size: 24px;
    line-height: 32px;
  `

const screen20Css = ({ screen20 }: ExecutionContext & { screen20?: boolean }) =>
  screen20 &&
  css`
    font-size: 20px;
    line-height: 28px;
  `

const screen18Css = ({ screen18 }: ExecutionContext & { screen18?: boolean }) =>
  screen18 &&
  css`
    font-size: 18px;
    line-height: 22px;
  `

const screen16Css = ({ screen16 }: ExecutionContext & { screen16?: boolean }) =>
  screen16 &&
  css`
    font-size: 16px;
    line-height: 20px;
  `

const screen14Css = ({ screen14 }: ExecutionContext & { screen14?: boolean }) =>
  screen14 &&
  css`
    font-size: 14px;
    line-height: 20px;
  `

export type { CustomTypography002Props }
export {
  screen14Css,
  screen16Css,
  screen18Css,
  screen20Css,
  screen24Css,
  screen28Css,
  screen32Css,
  screen36Css,
  screen38Css,
  screen40Css,
  screen52Css,
  screen64Css,
}
